import firebase, { isProduction } from './firebase';

const METHOD_POST = 'POST';
const METHOD_GET = 'GET';
const METHOD_DELETE = 'DELETE';
const METHOD_PATCH = 'PATCH';

const prodUrl = "https://api.hit.movie/hitmovie/";
const stageUrl = "https://test.hit.movie/hitmovie/";
const url = isProduction ? prodUrl : stageUrl;

const signup = "users/signup";
const verifySignup = "users/signup/verify";
const password = "users/password";
const login = "users/signin";
const reset = "users/password/reset";
const logout = "users/logout";
const poll = "users/poll";
const tvLogin = "tv/register/";
const getFees = "movie/initialfees";
const getCountries = "payments/countries/supported";
const addInitialData = "initialdata";
const generalInfo = "list/generalinfo";
const generateOtp = "otp";
const payListingFees = "listingfees";
const feesPaid = "update/initialfees/paid";
const saveMovie = "save/movie";
const getSingleUpload = "movie/uploads/";
const getUploads = "movie/uploads/lightweight/";
const getLanguages = "movies/location/languages";
const getLatestMovies = "movies/latest";
const getUpcomingMovies = "movies/upcoming";
const getPopularMovies = "movies/popular";
const getLanguageMovies = "movies/";
const getSharedURLMovie = "movies/shareurl";
const getUserMovies = "movies/all";
const getUserHistory = "movies/history";
const getMovieStream  = "video/stream/movie/";
const getTrailerStream  = "video/stream/trailer/";
const getMovieStreamProducer  = "video/stream/producer/movie/";
const addBusinessDetails  = "business/add/businessdetails/";
const updateBusinessDetails  = "business/update/businessdetails/";
const confirmBusinessDetails  = "business/confirm/businessdetails/";
const getBusinessDetails = "business/businessdetails/";
const getAddMovieObj = "movie/uploads/listingfees/unpaid";

const imageBusinessDetails = "businessdetails/image/url";
const imageBusinessOwner = "businessowner/image/url/";
const imageBankDetails = "bankdetails/image/url";
const imageCensorMovie = "movie/censor/image/url";
const imageMovie = "movie/image/url";

const getIdentityPutUrl = "identity/image/url/";
const verifyIdentity = "verify/identity/";
const deleteIdentity = "delete/identity/";
const otpIdentity = "identity/otp/";
const updateIdentity = "update/identity/";
const userIdentity = "user/identity/";
const getIdentitiesPageSize = "verify/identities/";
const getIdentitiesList = "verify/identities/";
const userIdMediaLinks = "identity/image/url/user/";

const likeDeleteMovie = "movie/like/";
const deleteMovie = "movie/like/remove/";
const connectedAccountCreate = "stripe/connectedaccount/new";
const connectedAccountVerify = "stripe/connectedaccount/verify";
const connectedAccountGet = "stripe/connectedaccount/";

const payMovieStripe = "stripe/movie/pay/";
const payIndiaMovieStripe = "stripe/movie/pay/india/";
const payMovieRazorpay = "razorpay/movie/pay/";
const completePayment = "movies/payment/complete";
const paymentSummaryStripe = "stripe/payments/summary/";
const paymentSummaryRazorpay = "razorpay/payments/summary/";
const paymentStatusListingFees = "stripe/listingfees/paymentstatus/";
const paymentStatusMovie = "stripe/movie/paymentstatus/";

export function parseJSON(response) {
    response.text().then(function(text) {
      console.log('text='+text);
    });
}

export async function loginApi(email, password) {
    console.log('loginApi');
    let okStatus = false, result = '';
    let tempObj = { emailAddress: email, password: password };
    console.log('login Obj='+JSON.stringify(tempObj));
    const response = await fetch(url+login,
        {
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify(tempObj)
        });
    okStatus = response.ok;
    if (response.status >= 200 && response.status <= 299) {
        console.log('login response header1='+response.headers);
        console.log('login response header2='+JSON.stringify(response.headers));
        let session = response.headers.get("hmat");
        localStorage.setItem('localStorageSession', session);
        localStorage.setItem('loginTime', Date.now());
        console.log('login session='+session);
        const jsonResponse = await response.json();
        result = jsonResponse;
        console.log('login userObject='+JSON.stringify(jsonResponse));
        localStorage.setItem('userObj', JSON.stringify(jsonResponse));
    } else {
        console.log('login error='+response.status, response.statusText);
        result = response.statusText ? response.statusText : 'Failed login.';
        try {
            const jsonResponse = await response.text();
            result = jsonResponse;
            console.log('request response='+(jsonResponse));    
        } catch(e) {
            console.log('error in request='+e);
        }
    }
    let loginResult = {'ok':okStatus, 'info':result};
    console.log('login USer='+(result));
    return loginResult;
}
export async function sendRequest(methodType, session, bodyParams, url) {
    console.log('Sending Request='+url);
    let header1 = {
        'Accept': '*/*',
        "Content-Type": "application/json"
    };
    if(session) {
        header1['hmat'] = session;
    }
    let fetchParams = {
        method: methodType,
        headers: header1,        
    }
    if(methodType!==METHOD_GET) {
        fetchParams['body'] = bodyParams;
    }
    console.log('body='+JSON.stringify(bodyParams));
    console.log('fetchParams='+JSON.stringify(fetchParams));
    let response = await fetch(url, fetchParams);
    let okStatus = response.ok, result = '';
    console.log('Sending Request='+url+' response Status='+response.status);
    if (response.status >= 200 && response.status <= 299) {
        console.log('login response='+(response));
        try {
            const jsonResponse = await response.json();
            result = jsonResponse;
        } catch(e) {
            result = true;
        }
        console.log('request response success');
    } else {
        console.log('login error='+response.status+' text='+response.statusText+' msg='+response.message);
        result = response.statusText ? response.statusText : 'Failed login.';
        try {
            const jsonResponse = await response.text();
            result = jsonResponse;
            console.log('request response='+(jsonResponse));    
        } catch(e) {
            console.log('error in request='+e);
        }
    }
    let loginResult = {'ok':okStatus, 'info':result, 'status': response.status};
    console.log('request message='+(result));
    return loginResult;
}
export async function setPassword(emailToken, password1, confirmPassword) {
    let tempObj = { emailToken: emailToken, password: password1, confirmPassword: confirmPassword };
    return sendRequest(METHOD_POST, null, JSON.stringify(tempObj), url+password);
} 
export async function signUpApi(email, ipAddress) {
    let tempObj = { ipAddress: ipAddress, emailAddress: email };
    return sendRequest(METHOD_POST, null, JSON.stringify(tempObj), url+signup);
}
export async function verifySignUpApi(emailToken) {
    let tempObj = { emailToken: emailToken };
    return sendRequest(METHOD_POST, null, JSON.stringify(tempObj), url+verifySignup);
}
export async function resetApi(email) {
    let tempObj = { emailAddress: email };
    return sendRequest(METHOD_POST, null, JSON.stringify(tempObj), url+reset);
}
export async function logoutApi(email) {
    let tempObj = { emailAddress: email };
    return sendRequest(METHOD_POST, null, JSON.stringify(tempObj), url+logout);
}
export async function tvLoginApi(session, email, token) {
    let tempObj = { "operation" : "verify", "initialToken" : token, "emailaddress": email  };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+tvLogin);
}
export async function pollApi(session) {
    console.log('calling poll api');
    return sendRequest(METHOD_POST, session, '', url+poll);
}
export async function getFeesApi(session) {
    console.log('calling fess api');
    return sendRequest(METHOD_GET, session, null, url+getFees);
}
export async function getCountriesApi(session) {
    console.log('calling countries api');
    return sendRequest(METHOD_GET, session, null, url+getCountries);
}
export async function getAddMovieObjApi(session) {
    console.log('calling getAddMovieObj api');
    return sendRequest(METHOD_GET, session, null, url+getAddMovieObj);
}
export async function getBusinessDetailsApi(session, movieUploadId) {
    console.log('calling getBusinessDetails api');
    return sendRequest(METHOD_GET, session, null, url+getBusinessDetails+movieUploadId);
}
export async function addInitialDataApi(session, fees, username, mobile, email, entity, country, movieName) {
    let tempObj = {
        "initialFees" : fees,
        "username": username,
        "mobile": mobile,
        "email": email,
        "legalEntityName" : entity,
        "legalEntityCountry" : country,
        "moviename" : movieName,
    };
    console.log('tempObj='+JSON.stringify(tempObj));
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+addInitialData);
}
export async function otpApi(session, operation, mobile, otp) {
    let tempObj = {
        "operation" : operation,
        "phonenumber" : mobile
    };
    if(otp) {
        tempObj['otp'] = otp;
    }
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+generateOtp);
}
export async function payInitialsFeesApi(session, initialFees, uploadId) {
    let tempObj = { uploadId : uploadId, initialFees: initialFees };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+payListingFees);
}
export async function feesPaidApi(session, uploadId) {
    let tempObj = { "uploadId" : uploadId };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+feesPaid);
}
export async function getUploadsApi(session) {
    console.log('calling get UploadsApi api');
    return sendRequest(METHOD_GET, session, null, url+getUploads);
}
export async function getUploadIdApi(session, id) {
    console.log('calling getUploadIdApi api');
    return sendRequest(METHOD_GET, session, null, url+getSingleUpload+id);
}
export async function saveMovieCastApi(session, uploadId, directors, writers, stars, producers, productionhouse) {

    let tempObj = { "uploadId" : uploadId, "directors": directors, 
    "stars": stars, "writers": writers, "producers": producers, "productionhouse": productionhouse };
    console.log('tempObj='+JSON.stringify(tempObj));
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+saveMovie);
}
export async function imageBusinessDetailsApi(session, uploadId, businessDetailsId, operation, type, filename) {
    let tempObj = { uploadId : uploadId, businessDetailsId: businessDetailsId, operation: operation, type: type, filename: filename };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+imageBusinessDetails);
}
export async function deleteImageBusinessDetailsApi(session, uploadId, businessDetailsId, operation, type) {
    let tempObj = { uploadId : uploadId, businessDetailsId: businessDetailsId, operation: operation, type: type };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+imageBusinessDetails);
}
export async function imageOwnerDetailsApi(session, uploadId, businessOwnerId, operation, type, filename) {
    let tempObj = { uploadId : uploadId, businessOwnerId: businessOwnerId, operation: operation, type: type, filename: filename };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+imageBusinessOwner);
}
export async function deleteImageOwnerDetailsApi(session, uploadId, businessOwnerId, operation, type) {
    let tempObj = { uploadId : uploadId, businessOwnerId: businessOwnerId, operation: operation, type: type };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+imageBusinessOwner);
}
export async function imageBankDetailsApi(session, uploadId, bankDetailsId, operation, type, filename) {
    let tempObj = { uploadId : uploadId, bankDetailsId: bankDetailsId, operation: operation, type: type, filename: filename };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+imageBankDetails);
}
export async function deleteImageBankDetailsApi(session, uploadId, bankDetailsId, operation, type) {
    let tempObj = { uploadId : uploadId, bankDetailsId: bankDetailsId, operation: operation, type: type };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+imageBankDetails);
}
export async function imageCensorMovieApi(session, uploadId, movieId, operation, type, filename) {
    let tempObj = { uploadId : uploadId, movieId: movieId, operation: operation, type: type, filename: filename };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+imageCensorMovie);
}
export async function deleteImageCensorMovieApi(session, uploadId, movieId, operation, type) {
    let tempObj = { uploadId : uploadId, movieId: movieId, operation: operation, type: type };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+imageCensorMovie);
}
export async function imageMovieApi(session, movieId, operation, mediaSize, mediaType, filename) {
    let tempObj = { mediaSize : mediaSize, movieId: movieId, operation: operation, mediaType: mediaType, filename: filename };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+imageMovie);
}
export async function likeMovieApi(session, userId, uploadId, isDelete) {
    let tempObj = { upload: { id: uploadId }};
    let likeUrl = likeDeleteMovie;
    if(isDelete) {
        likeUrl = deleteMovie;
        tempObj = { user: { id: userId }, upload: { id: uploadId }};
    }
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+likeUrl);
}
export async function payMovieStripeApi(session, uploadId, isIndia) {
    let tempObj = { uploadId: uploadId };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+(isIndia ? payIndiaMovieStripe : payMovieStripe));
}
export async function payMovieRazorpayApi(session, uploadId) {
    let tempObj = { uploadId: uploadId };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+payMovieRazorpay);
}
export async function completePaymentApi(session, uploadId) {
    let tempObj = { uploadId: uploadId };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+completePayment);
}
export async function paymentSummaryStripeApi(session, uploadId, toDate) {
    let tempObj = { uploadId: uploadId, fromdate: toDate-2592000, todate: toDate };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+paymentSummaryStripe);
}
export async function paymentSummaryRazorpayApi(session, uploadId, toDate) {
    let tempObj = { uploadId: uploadId, fromdate: toDate-2592000, todate: toDate };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+paymentSummaryRazorpay);
}
export async function paymentStatusApi(session) {
    console.log('calling paymentStatusApi api');
    return sendRequest(METHOD_GET, session, null, url+paymentStatusListingFees);
}
export async function paymentMovieStatusApi(session) {
    console.log('calling paymentMovieStatusApi api');
    return sendRequest(METHOD_GET, session, null, url+paymentStatusMovie);
}
export async function connectedAccountCreateApi(session, uploadId) {
    let tempObj = { uploadId: uploadId };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+connectedAccountCreate);
}
export async function connectedAccountVerifyApi(session, uploadId) {
    let tempObj = { uploadId: uploadId };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+connectedAccountVerify);
}
export async function connectedAccountGetApi(session, uploadId) {
    let tempObj = { uploadId: uploadId };
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+connectedAccountGet);
}
export async function saveMovieImageApi(session, uploadId, mediaFilenames) {

    let tempObj = { "uploadId" : uploadId, "mediaFilenames": mediaFilenames };
    console.log('tempObj='+JSON.stringify(tempObj));
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+saveMovie);
}
export async function saveMovieApi(session, tempObj) {
    console.log('tempObj='+JSON.stringify(tempObj));
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+saveMovie);
}
export async function addBusinessDetailsApi(session, tempObj) {
    console.log('tempObj='+JSON.stringify(tempObj));
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+addBusinessDetails);
}
export async function updateBusinessDetailsApi(session, tempObj, confirm) {

    // let businessDocuments = [{ 'type': 'PAN', 'filename': panFile }, { 'type': 'GST', 'filename': gstFile }, { 'type': 'RegistrationDocument', 'filename': regDocFile }];
    // let businessOwnerDocuments = [{ 'type': 'PAN', 'filename': ownerPanFile }, { 'type': 'AADHARFRONT', 'filename': ownerAadharFront }, { 'type': 'AADHARBACK', 'filename': ownerAadharBack }];
    // let bankDocuments = [{ 'type': 'CHEQUE', 'filename': chequeFile }];

    // let tempObj = { businessDetailsId : businessDetailsId, businessName: businessName, mobile: mobile, website: website, email: email,
    // panNumber: panNumber, regDocName: regDocName, gstNumber: gstNumber, addressLine1: addressLine1, addressLine2: addressLine2,
    // city: city, state: state, postalcode: postalcode, businessDocuments: businessDocuments, 

    // businessOwnerId: businessOwnerId, fullName: fullName, dob: dob, designation: designation, ownerMobile: ownerMobile, 
    // ownerEmail: ownerEmail, ownerPanNumber: ownerPanNumber, aadharNumber: aadharNumber, ownerAddressLine1: ownerAddressLine1, 
    // ownerAddressLine2: ownerAddressLine2, ownerCity: ownerCity, ownerState: ownerState, ownerPostalcode: ownerPostalcode, 
    // businessOwnerDocuments: businessOwnerDocuments, 

    // bankDetailsId: bankDetailsId, bankName: bankName, bankBranch: bankBranch, ifscCode: ifscCode, accountNumber: accountNumber, 
    // bankDocuments: bankDocuments };
    let updateUrl = confirm ? confirmBusinessDetails : updateBusinessDetails;
    console.log('tempObj='+JSON.stringify(tempObj));
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+updateUrl);
}

export async function getLanguagesApi(session) {
    console.log('calling getLanguages api');
    return sendRequest(METHOD_GET, session, null, url+getLanguages);
}
export async function getLatestMoviesApi(session) {
    console.log('calling getLanguages api');
    return sendRequest(METHOD_GET, session, null, url+getLatestMovies);
}
export async function getGeneralInfoApi(session) {
    console.log('calling getLatestMovies api');
    let header1 = { 'Accept': '*/*', "Content-Type": "application/json", "hmat": session };
    let fetchParams = { method: METHOD_GET, headers: header1 };
    let response = await fetch(url+generalInfo, fetchParams);
    if(response.ok) {
        let firebaseToken = response.headers.get("hmft");
        if(firebaseToken) {
            localStorage.setItem('firebaseToken', firebaseToken);
        }
        let jsonResponse = await response.json();
        let obj = { ok: true, info: jsonResponse };
        console.log('firebaseToken='+firebaseToken+' json='+jsonResponse);
        return obj;
    } 
    return { ok: false, info: '' };
}
export async function getPopularMoviesApi(session) {
    console.log('calling getPopularMovies api');
    return sendRequest(METHOD_GET, session, null, url+getPopularMovies);
}
export async function getUpcomingMoviesApi(session) {
    console.log('calling getUpcomingMovies api');
    return sendRequest(METHOD_GET, session, null, url+getUpcomingMovies);
}
export async function getUserMoviesApi(session) {
    console.log('calling getUserMovies api');
    return sendRequest(METHOD_GET, session, null, url+getUserMovies);
}
export async function getUserHistoryApi(session) {
    console.log('calling getUserHistory api');
    return sendRequest(METHOD_GET, session, null, url+getUserHistory);
}
export async function getSharedURLMovieApi(session, shareUrl) {
    let tempObj = { shareUrl: shareUrl };
    console.log('calling getSharedURLMovie api');
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+getSharedURLMovie);
}
export async function getLanguageMoviesApi(session, language) {
    console.log('calling getLanguageMovies api language='+language);
    return sendRequest(METHOD_GET, session, null, url+getLanguageMovies+language);
}
export async function getMovieStreamApi(session, movieUploadId, isProducer) {
    console.log('calling getMovieStream api');
    let apiUrl = isProducer ? getMovieStreamProducer : getMovieStream;
    return sendRequest(METHOD_GET, session, null, url+apiUrl+movieUploadId);
}
export async function getTrailerStreamApi(session, movieUploadId) {
    console.log('calling getTrailerStream api');
    return sendRequest(METHOD_GET, session, null, url+getTrailerStream+movieUploadId);
}
export async function getMovieStreamProducerApi(session, movieUploadId) {
    console.log('calling getMovieStreamProducer api');
    return sendRequest(METHOD_GET, session, null, url+getMovieStreamProducer+movieUploadId);
}
export async function getIdentityPutUrlApi(session, frontID, backID, video) {
    let tempObj = { operation: "put_aws", ID_FRONT: frontID, ID_BACK: backID, ID_VIDEO: video };
    console.log('calling get IdentityPutUrl api');
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+getIdentityPutUrl);
}
export async function verifyIdentityApi(session, frontID, backID, video) {
    let tempObj = { ID_FRONT: frontID, ID_BACK: backID, ID_VIDEO: video };
    console.log('calling get IdentityPutUrl api');
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+verifyIdentity);
}
export async function deleteIdentityApi(session, otp) {
    let tempObj = { otp: otp };
    console.log('calling delete IdentityPutUrl api');
    return sendRequest(METHOD_DELETE, session, JSON.stringify(tempObj), url+deleteIdentity);
}
export async function otpIdentityApi(session, operation, otp) {
    let tempObj = { operation: operation };
    if(otp) {
        tempObj['otp'] = otp;
    }
    console.log('calling otp Identity PostUrl api');
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+otpIdentity);
}
export async function updateIdentityApi(session, verificationId, verificationStatus) {
    let tempObj = { verificationStatus: verificationStatus, verificationId: verificationId };
    console.log('calling update IdentityPutUrl api');
    return sendRequest(METHOD_PATCH, session, JSON.stringify(tempObj), url+updateIdentity);
}
export async function getIdentitiesPageSizeApi(session, state) {
    console.log('calling get Identities page size api');
    return sendRequest(METHOD_GET, session, null, url+getIdentitiesPageSize+state+'/size');
}
export async function getIdentitiesListApi(session, state, pageNumber) {
    console.log('calling get Identities list api');
    return sendRequest(METHOD_GET, session, null, url+getIdentitiesList+state+'?page='+pageNumber);
}
export async function getUserIdentitiesListApi(session, emailaddress, state) {
    let tempObj = { emailaddress: emailaddress, state: state };
    console.log('calling get user Identities list api');
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+userIdentity+'?page=1');
}
export async function getUserIdMediaLinksApi(session, emailaddress) {
    let tempObj = { emailaddress: emailaddress };
    console.log('calling get user Identities list api');
    return sendRequest(METHOD_POST, session, JSON.stringify(tempObj), url+userIdMediaLinks);
}
export async function fileUploadApi(session, url, file) {
    let contentType = url.includes('pdf') ? 'application/pdf' : 'text/plain';
    let header1 = {
        'Content-Type': contentType,
        'hmat': session,
    };
    let fetchParams = { method: 'PUT', headers: header1, body: file };
    console.log('uploading File fetchParams='+JSON.stringify(fetchParams));
    let response = await fetch(url, fetchParams);
    console.log('Sending Request='+url+' response Status='+response.status+' okStatus='+response.ok);
    if (response.status >= 200 && response.status <= 299) {
        console.log('upload response='+response);
        return true;
    } else {
        console.log('upload failed='+(response));
        return false;
    }
}
export async function videoUploadApi(session, url, file, videoType) {
    try {
        let contentType = videoType ? videoType : 'text/plain';
        let header1 = {
            'Content-Type': contentType,
            'hmat': session,
        };
        let fetchParams = { method: 'PUT', headers: header1, body: file };
        console.log('uploading File fetchParams='+JSON.stringify(fetchParams));
        let response = await fetch(url, fetchParams);
        console.log('Sending Request='+url+' response Status='+response.status+' okStatus='+response.ok);
        if (response.status >= 200 && response.status <= 299) {
            console.log('upload response='+response);
            return true;
        } else {
            console.log('upload failed='+(response));
            return false;
        }
    } catch(e) {
        return false;
    }
}
// Code to validate email address entered by the user
export function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
export function validateMobile(phone) {
    const re = /^[+]?\d+$/;
    return re.test(String(phone));
}
export function removeWhitespaceSpeicals(str) {
    let newStr = str.replace(/[^0-9a-zA-Z.]/g, '_');
    return newStr;
}
// Get base 64 date from the file uploaded by the user
export async function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}
export function dateSecondsToString(date) {
    let movieReleaseDate = new Date(date*1000).toDateString();
    console.log('date string='+movieReleaseDate);
    return movieReleaseDate;
}
export function dateMonthsString2(date) {
    let movieReleaseDate = new Date(date);
    let finalDate = movieReleaseDate.toUTCString();
    console.log('finalDate1='+finalDate);
    finalDate = finalDate.substring(5, 16);
    console.log('finalDate2='+finalDate);
    return finalDate;
}
// Returns date in the following format - Mar 03 2021
export function dateMonthsString(date) {
    let movieReleaseDate = new Date(date);
    let finalDate = movieReleaseDate.toDateString();
    // console.log('finalDate1='+finalDate);
    finalDate = finalDate.substring(4, 15);
    // console.log('finalDate2='+finalDate);
    return finalDate;
}
// Returns date in the following format - Mar 03 2021
export function dateToYearMonthDateString(date) {
    let movieReleaseDate = new Date(date*1000);
    let finalDate = movieReleaseDate.toDateString();
    finalDate = finalDate.substring(4, 15);
    return finalDate;
}
// Returns date in the following format - Sun Aug 22 2021 00:55
export function dateMonthTimeString(date) {
    let showDateString = new Date(date*1000).toString();
    let indexOfGMT = showDateString.indexOf('GMT');
    return showDateString.substring(0, indexOfGMT-4);
}
// Returns date in the following format - Aug 22 2021 00:55
export function dateMonthTimeNotDayString(date) {
    let showDateString = new Date(date*1000).toString();
    let indexOfGMT = showDateString.indexOf('GMT');
    return showDateString.substring(4, indexOfGMT-4);
}
// Format the string for any type of escape characters
export function stringFormat(string, entities) {
    let summary = string;
    try {
        summary = string.split('\\n').join("\n");
        summary = summary.replace(/\\/g, "");
        summary = entities.decode(summary);
    } catch(e) {  };
    return summary;
}
// Return gmt time in milliseconds by offsetting time from the local time
export function localToGMTTime(date) {
    var d4 = new Date(date);
    var offsetInHours = d4.getTimezoneOffset();
    d4.setMinutes(d4.getMinutes() - offsetInHours);
    return d4.getTime();
}
// Return local time in milliseconds by offsetting time from the gmt time
export function gmtToLocalTime(date) {
    var d4 = new Date(date);
    var offsetInHours = d4.getTimezoneOffset();
    d4.setMinutes(d4.getMinutes() + offsetInHours);
    return d4.getTime();
}
// Returns date in the format eg. 4-Sep-2021
export function getMmmDate(date) {
    let d4 = new Date(date*1000);
    let day = d4.getDate();
    day = appendZero(day);
    let shortMonth = d4.toLocaleString('en-us', { month: 'short' });
    let year = d4.getFullYear();
    // console.log('day='+day+' month='+shortMonth+' yea/r='+year+' date='+date);
    return day+'-'+shortMonth+'-'+year;
}
// Returns date in the format eg. 4-Sep-2021
export function getMmmHhMmDate(date) {
    let d4 = new Date(date*1000);
    let day = d4.getDate();
    day = appendZero(day);
    let shortMonth = d4.toLocaleString('en-us', { month: 'short' });
    let year = d4.getFullYear();
    let hours = d4.getHours();
    hours = appendZero(hours);
    let minutes = d4.getMinutes();
    minutes = appendZero(minutes);
    // console.log('day='+day+' month='+shortMonth+' year='+year+' date='+date);
    return day+'-'+shortMonth+'-'+year+' '+hours+':'+minutes;
}
// append zero to single digit number if required
export function appendZero(value) {
    let newValue = value<10 ? '0'+value : value;
    return newValue;
}
// Returns true if the browser is Safari
export function isSafariBrowser() {
    // Safari 3.0+ "[object HTMLElementConstructor]" 
    var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
    return isSafari;
}
export function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
}
export function getBrowser () {
    var test = function(regexp) {return regexp.test(window.navigator.userAgent)}
    switch (true) {
        case test(/edg/i): return "Microsoft Edge";
        case test(/trident/i): return "Microsoft Internet Explorer";
        case test(/firefox|fxios/i): return "Mozilla Firefox";
        case test(/opr\//i): return "Opera";
        case test(/ucbrowser/i): return "UC Browser";
        case test(/samsungbrowser/i): return "Samsung Browser";
        case test(/chrome|chromium|crios/i): return "Google Chrome";
        case test(/safari/i): return "Apple Safari";
        default: return "Other";
    }
}
export function getDateFirebase() {
    let dateObject = new Date();
    let day = dateObject.getDate();
    let month = dateObject.getMonth()+1;
    let year = dateObject.getFullYear();
    let hours = dateObject.getUTCHours();
    let minutes = dateObject.getUTCMinutes();
    let dateNode = appendZero(day)+'-'+appendZero(month)+'-'+year+'-'+appendZero(hours)+''+appendZero(minutes);
    return dateNode;
}
export function writeEventToDb(updates) {
    if(isProduction) {
        let dateTimeNode = getDateFirebase();
        console.log('setting analytics data to dateTimeNode='+dateTimeNode+' updates='+JSON.stringify(updates));
        firebase.database().ref('analytics/'+dateTimeNode+'/non-user-events/').update(updates);    
    }
}
export function writeUserEventToDb(userId, infoObject) {
    if(isProduction) {
        let dateTimeNode = getDateFirebase();
        infoObject['appVersion'] = '0.4';
        console.log('setting analytics data to dateTimeNode='+dateTimeNode+' infoObject='+JSON.stringify(infoObject));
        firebase.database().ref('analytics/'+dateTimeNode+'/user-events/'+userId).push(infoObject);
    }
}
